import { API_URL } from '../../const';

import { makeApiCall } from '../../_common/api.utils';
/*********  START GET FIELD OFFICER LIST  *********/
export const getFieldOfficerListAPI = (payload: any) => {
	const data = {
		GetFieldOfficerListToken: payload,
	};
	const url = `${API_URL}GetFieldOfficerList`;
	return makeApiCall(url, data);
};
/*********  END GET FIELD OFFICER LIST  *********/

/*********  START GET FIELD OFFICER LOCATION DETAILS  *********/
export const getFieldOfficerLocationAPI = (payload: any) => {
	const data = {
		GetFieldOfficerLocationToken: payload,
	};
	const url = `${API_URL}GetFieldOfficerLocation`;
	return makeApiCall(url, data);
};
/*********  END GET FIELD OFFICER LOCATION DETAILS  *********/
